export default "__VITE_ASSET__DBRGUDGG__"